declare global {
    interface Window {
        NREUM: typeof import("new-relic-browser") | undefined;
    }
}

let lastException: any;

/**
 * Handle an error by sending data to New Relic (if available).
 */
function handleError(err: Error | Response | string, ...args: string[]): void {
    // checking for duplicate exceptions so we don't spam New Relic
    if (err === lastException) {
        return;
    }

    lastException = err;

    if (typeof Response != "undefined" && err instanceof Response) {
        try {
            throw new Error(
                `Request for ${err.url} responded with ${err.status} ${err.statusText}`
            );
        } catch (e) {
            err = e;
        }
    } else if (!(err instanceof Error)) {
        let message: string;
        try {
            message = JSON.stringify(err);
        } catch (e) {
            message = err + "";
        }
        try {
            throw new Error(message);
        } catch (e) {
            err = e;
        }
    }

    console.error(...args, err);

    if (window.NREUM) {
        window.NREUM.noticeError(err);
    }
}

// public API
export default {
    error: handleError,
};
